import { NavlinkPath } from "@/services/router-config";

// TODO: Remove settlement from exception list when backend implements permissions
const exceptionPath: string[] = [
  NavlinkPath.setting,
  NavlinkPath.ultilities,
  NavlinkPath.home,
  NavlinkPath.settlement, // Temporary bypass for settlement page
  NavlinkPath.settlementDetail, // Bypass for settlement detail page
  NavlinkPath.reconciliation, // Temporary bypass for reconciliation page
  NavlinkPath.reconciliationDetail, // Bypass for reconciliation detail page
  NavlinkPath.aml, // Temporary bypass for AML page
];

export function routerIntercepter({
  path,
  roles,
}: {
  path: string;
  roles: {
    id: number;
    routerPaths: string[];
  }[];
}): boolean {
  let ret = false;
  if (exceptionPath.includes(path)) {
    return true;
  }
  // Bypass AML detail pages (dynamic routes)
  if (path.startsWith(NavlinkPath.aml)) {
    return true;
  }
  for (let i = 0; i < roles.length; i++) {
    if (roles[i].routerPaths.includes(path)) {
      ret = true;
      break;
    }
  }

  return ret;
}
